import { useEffect, useState } from 'react';
import { userRoutes } from '../../../../../../../utils/RoutesApi';
import axios from 'axios';
import { Button, ColContent, Container, Divider, RowContent } from './styles';
import { transformMaskCurrency } from '../../../../../../../utils/transformMaskCurrency';
import moment from 'moment';
import { ButtonComponent } from '../../../../../../../components/ButtonComponent';
import { whatsAppLinkApi } from '../../../../../../../utils/apiWhatsapp';
import { ModalDesigner } from '../../../../../../../components/ModalDesigner';
import { useHistory } from 'react-router-dom';

export interface IPropsPlan {
  NomePlano: string;
  Status: string;
  StatusPagamentoCorrente: string;
  SubscriptionId: string;
  UserName: string;
  Valor: number;
  cardLastDigitsCard: number | null;
  card_brand: number | null;
  currentPeriodEnd: string;
  currentPeriodStart: string;
  manageUrl: string;
  paymentMethod: string;
}

export interface IPropsPlanIR {
  NomePlano: string;
  Status: string;
  StatusPagamentoCorrente: string;
  SubscriptionId: string;
  UserName: string;
  Valor: number;
  cardLastDigitsCard: number | null;
  card_brand: number | null;
  currentPeriodEnd: string;
  currentPeriodStart: string;
  manageUrl: string;
  paymentMethod: string;
}

export function MyPlan() {
  const [plan, setPlan] = useState<IPropsPlan | null>(null);
  const router = useHistory();
  const [loading, setLoading] = useState<boolean>(false);
  const [modalConfirmCancellationPlan, setModalConfirmCancellationPlan] =
    useState<boolean>(false);

  useEffect(() => {
    handlePayment();
  }, []);

  async function handlePayment() {
    setLoading(true);
    await axios
      .get(`${process.env.REACT_APP_API_URL}${userRoutes.STATUS_PAYMENT}`)
      .then((response) => {
        if (
          !!response.data.NomePlano === false ||
          response.data.Status === 'canceled'
        ) {
          setPlan(null);
        }
        setPlan(response.data);
      })
      .catch((err) => {
        //@ts-ignore
        setLoading(false);
        setPlan(null);
      });
    setLoading(false);
  }

  function redirectPaymentAPI(link: string) {
    if (link.includes('pay.hotmart')) return window.open(`https://${link}`);
    window.open(`${link.replace('www.', '')}`);
  }

  return (
    <Container>
      <RowContent>
        {plan ? (
          <>
            <ColContent>
              <header>
                <h1>Assinatura</h1>
                <h2>IBox 6</h2>
              </header>
              <Divider />
              <main>
                <header>
                  <h3>
                    {plan.NomePlano === 'bônus' ? 'Bônus' : plan.NomePlano}
                  </h3>
                  <span
                    style={
                      plan.Status === 'paid' ||
                      plan.Status === 'pago' ||
                      plan.Status === 'bonus'
                        ? { color: 'green' }
                        : { color: 'red' }
                    }
                  >
                    {plan.paymentMethod === 'hotmart'
                      ? 'Hotmart'
                      : plan.Status === 'paid' || plan.Status === 'pago'
                      ? 'Pago'
                      : plan.Status === 'canceled'
                      ? 'Cancelado'
                      : plan.Status === 'bonus'
                      ? 'Bonus'
                      : 'Pendente'}
                  </span>
                </header>

                <p>
                  Valor do plano:{' '}
                  {plan.Valor ? (
                    <strong>{transformMaskCurrency(plan.Valor)}</strong>
                  ) : (
                    ' - '
                  )}
                </p>

                <p>
                  Tipo de pagamento:{' '}
                  <strong>
                    {plan.paymentMethod === 'credit_card'
                      ? 'Cartão'
                      : plan.paymentMethod === 'hotmart'
                      ? 'Hotmart'
                      : plan.Status === 'bonus'
                      ? 'Bônus'
                      : 'Boleto'}
                  </strong>
                </p>
                {plan.currentPeriodStart && (
                  <p>
                    Ínicio:{' '}
                    <strong>
                      {moment(plan.currentPeriodStart).format('LL')}
                    </strong>
                  </p>
                )}
                {plan.currentPeriodEnd && (
                  <p>
                    Término:{' '}
                    <strong>
                      {moment(plan.currentPeriodEnd).format('LL')}
                    </strong>
                  </p>
                )}
              </main>
              <footer>
                {plan.Status !== 'bonus' && (
                  <Button
                    className="gestãoPagamento"
                    background="#EC6643"
                    color="#FFF"
                    onClick={() => {
                      if (plan.paymentMethod === 'InscricaoCurso') {
                        router.push('pagamentos');
                      } else {
                        redirectPaymentAPI(
                          plan.paymentMethod === 'hotmart'
                            ? 'https://hotmart.com/pt-br'
                            : plan.manageUrl
                        );
                      }
                    }}
                  >
                    Gestão de pagamento
                  </Button>
                )}
                {plan.Status !== 'paid' && plan.Status !== 'unpaid' && (
                  <>
                    <Button
                      background="#EC6643"
                      color="#FFF"
                      onClick={() => router.push('pagamentos')}
                    >
                      Escolher plano
                    </Button>
                  </>
                )}
                {plan.Status !== 'canceled' &&
                  plan.paymentMethod !== 'hotmart' &&
                  plan.Status !== 'bonus' && (
                    <>
                      <ButtonComponent
                        variant="link"
                        onClick={() => setModalConfirmCancellationPlan(true)}
                      >
                        Cancelar plano
                      </ButtonComponent>
                    </>
                  )}
                <p>
                  Qualquer situação de problemas de pagamento e/ou mudança de
                  plano, entrar em contato com{' '}
                  <a href={whatsAppLinkApi}>nosso suporte</a>.
                </p>
              </footer>
            </ColContent>
          </>
        ) : (
          <>
            <ColContent>
              <header>
                <h1>Assinatura</h1>
                <h2>IBox 6</h2>
              </header>
              <Divider />
              <main>
                <header>
                  <h3>iBox6 Free</h3>
                  <span>Gratuíto</span>
                </header>
              </main>
              <footer>
                <Button
                  background="#EC6643"
                  color="#FFF"
                  onClick={() => router.push('pagamentos')}
                >
                  Escolher plano
                </Button>

                <p>
                  Qualquer situação de problemas de pagamento e/ou mudança de
                  plano, entrar em contato com{' '}
                  <a href={whatsAppLinkApi}>nosso suporte</a>.
                </p>
              </footer>
            </ColContent>
          </>
        )}
      </RowContent>

      <ModalDesigner
        title="Realmente deseja cancelar o plano?"
        id="cancelar"
        isOpen={modalConfirmCancellationPlan}
        setState={setModalConfirmCancellationPlan}
        size="sm"
      >
        <div>
          <p style={{ fontSize: '1rem', color: 'black' }}>
            <p>
              Clicar em <strong>Mostrar Detalhes</strong>
            </p>
            <p>
              Depois clicar em <strong>Configurar pagamento</strong>
            </p>
            <p>
              Depois clicar em <strong>Deseja cancelar sua assinatura?</strong>
            </p>
          </p>
          <br />
          <footer
            style={{
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'center',
              alignItems: 'center',
              gap: '1rem',
              flexWrap: 'wrap',
            }}
          >
            <ButtonComponent
              onClick={() => {
                if (plan) {
                  redirectPaymentAPI(
                    plan.paymentMethod === 'hotmart'
                      ? 'https://hotmart.com/pt-br'
                      : plan.manageUrl
                  );
                } else {
                  window.open('https://consumer.hotmart.com/main');
                }
                setModalConfirmCancellationPlan(false);
              }}
              variant="link"
            >
              Quero cancelar
            </ButtonComponent>
            <ButtonComponent
              onClick={() => setModalConfirmCancellationPlan(false)}
            >
              Quero continuar no iBox6
            </ButtonComponent>
          </footer>
        </div>
      </ModalDesigner>
    </Container>
  );
}
